import React, { Component } from 'react';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import { Save, Cancel, Edit } from '@mui/icons-material';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import * as moment from 'moment';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import AccountsApi from '../../api/accounts';
import { showError, confirmAction } from '../../actions/uiActions';
import AnalysisTools from '../../utils/AnalysisTools';
import Formatter from '../../utils/Formatter';


class EmploymentInfo extends Component {
  constructor(props) {
    super(props);
    const employment = this.props.account.employment || {};
    this.state = {
      busy: false,
      edit_employment_info: false,
      employment_info: {
        pslf: employment.pslf || false,
        tlf: employment.tlf || false,
        occupation: employment.occupation,
        payments: employment.payments || '',
        applied: employment.applied || '',
        teacher_type: employment.teacher_type || '',
        years_of_experience: employment.years_of_experience || '',
        tepslf: employment.tepslf || {},
        employer_contribution: employment?.contribution?.value || '',
        lifetime_contribution: employment?.contribution?.lifetime_contribution || '',
        total_companies_worked_for: employment.total_companies_worked_for || '',
        contributionType: employment?.contribution?.type || "",
        
      }
    };
  }



  renderContributionValue() {
    if (this.state.employment_info.contributionType === "percentage") {
      return (
        <>
        {this.state.employment_info.employer_contribution}%
        </>
      )
    }
    if (this.state.employment_info.contributionType === "currency") {
      return (
        <>
          {`$${Formatter.money(this.state.employment_info.employer_contribution)}`}
        </>
      )
    }
  }

  getOccupation() {
    if (!this.props.account.employment) return 'Unknown';
    else
      switch (this.props.account.employment.occupation) {
        case 1:
          return 'Teacher';
        case 2:
          return 'Employee at a child or family services agency';
        case 6:
          return 'Librarian with master’s degree at Title I school';
        case 3:
          return 'Faculty member at a tribal college or university';
        case 4:
          return 'Firefighter';
        case 5:
          return 'Law enforcement officer';
        case 7:
          return 'Military service';
        case 8:
          return 'Nurse or medical technician';
        case 9:
          return 'Professional provider of early intervention (disability) services';
        case 10:
          return 'Public defender';
        case 11:
          return 'Speech pathologist with master’s degree at Title I school';
        case 12:
          return 'Volunteer service (AmeriCorps VISTA or Peace Corps)';
        case 13:
          return 'Clergy';
        default:
          return 'Other';
      }
  }

  updateEmploymentInfoApi = async () => {
    try {
      await AccountsApi.updateEmploymentInfo({
        id: this.props.id,
        pslf: this.state.employment_info.pslf || false,
        occupation: this.state.employment_info.occupation,
        teacher_type: this.state.employment_info.teacher_type,
        applied: this.state.employment_info.applied || false,
        tlf: this.state.employment_info.tlf || false,
        payments: this.state.employment_info.payments || 0,
        last_update_by: 'peoplejoy',
        tepslf: this.state.employment_info.tepslf,
        total_companies_worked_for: this.state.employment_info.total_companies_worked_for,
        years_of_experience: this.state.employment_info.years_of_experience,
        contribution: {
          type: this.state.employment_info.contributionType,
          value: Number(this.state.employment_info.employer_contribution),
          lifetime_contribution: Number(this.state.employment_info.lifetime_contribution),
        }
      }
      );

      const employmentInfo = {
        ...this.state.employment_info,
        contribution: {
          type: this.state.employment_info.contributionType,
          value: this.state.employment_info.employer_contribution,
          lifetime_contribution: this.state.employment_info.lifetime_contribution
        }
      }
      delete employmentInfo.contributionType
      delete employmentInfo.employer_contribution
      delete employmentInfo.lifetime_contribution
      this.props.onEmploymentSaved(employmentInfo);
      this.setState({ busy: false, edit_employment_info: false });
    } catch (error) {
      this.setState({ busy: false }, this.props.showError);
    }
  };

  updateEmploymentInfo = () => {
    if (this.state.employment_info.occupation === '') {
      return this.props.showError('Please select an occupation');
    } else if (
      AnalysisTools.getCummulativePSLFMonths(this.props.account) > 0 &&
      this.state.employment_info.payments -
        AnalysisTools.getCummulativePSLFMonths(this.props.account) >
        12
    ) {
      this.setState({ busy: true });
      this.props.confirmAction(
        `The borrower's reported Months Worked for Nonprofit far exceeds the Cummulative Matched Months
            reported on the MSD file. This may significantly overestimate their forgiveness amount. Do you wish to continue?`,
        () => this.updateEmploymentInfoApi(),
        'Matched Months exceeded',
        'Yes',
        'No',
        () => this.setState({ edit_employment_info: false, busy: false })
      );
    } else {
      this.setState({ busy: true });
      this.updateEmploymentInfoApi();
    }
  };

  hasUserAppliedForPSLF = () => {
    if (!this.props.account.employment) {
      return 'Unknown';
    }
    let text = this.props.account.employment.applied ? "Yes" : "No";
    if (this.props.account.employment.occupation == 1) {
      text += ` / ${this.props.account.employment.tlf ? 'Yes' : 'No'}`;
    }
    return text;
  }


  updateEmploymentContribution = (e) => {
    const value = e.target.value
    if (this.state.employment_info.contributionType === "percentage" && value > 100) {
      return
    }
    this.setState({
      employment_info: {
        ...this.state.employment_info,
        employer_contribution: e.target.value
      }
    })

  }

  render() {
    return (
      <div className="col-4" style={{ marginBottom: '20px' }}>
        <Paper>
          <div className="full-width padding">
            <div className="action-buttons">
              {this.state.edit_employment_info && this.state.busy && (
                <div style={{ padding: '10px' }}>
                  <CircularProgress size={24} />
                </div>
              )}
              {!this.state.edit_employment_info && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() =>
                      this.setState({ edit_employment_info: true })
                    }
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              )}
              {this.state.edit_employment_info && !this.state.busy && (
                <Tooltip title="Save Changes">
                  <IconButton onClick={this.updateEmploymentInfo}>
                    <Save />
                  </IconButton>
                </Tooltip>
              )}
              {this.state.edit_employment_info && !this.state.busy && (
                <Tooltip title="Cancel Changes">
                  <IconButton
                    onClick={() =>
                      this.setState({ edit_employment_info: false })
                    }
                  >
                    <Cancel />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            Employment{' '}
            {AnalysisTools.hasRecertificationPending(this.props.account) &&
              (!(this.props.account.employment || {}).updated ||
                (this.props.account.employment || {}).updated <
                  AnalysisTools.getRecertificationThreshold()) && (
                <div className="indicator-badge">update required</div>
              )}
            <div className="indicator-badge-gray">
              {((this.props.account.confirmations || {}).finance_last_update_by ===
                  'peoplejoy') ||
              ((this.props.account.confirmations || {}).employment_last_update_by ===
                  'peoplejoy')
                ? 'PeopleJoy '
                : 'User '}
              last confirmed Employment Information on{' '}
              {moment(
                ((this.props.account.confirmations || {}).finance_employment) ||
                  (this.props.account.employment || {}).updated,
                'X'
              ).format('MM/DD/YYYY')}
            </div>
            <div className="line-break" />
            <div className="full-width">
              <div className="info-block">
                {!this.state.edit_employment_info && (
                  <div>
                    <label>Works for Non-Profit</label>
                    {this.props.account.employment
                      ? (this.props.account.employment).pslf
                        ? 'Yes'
                        : 'No'
                      : 'Unknown'}
                  </div>
                )}
                {this.state.edit_employment_info && (
                  <FormControl className="full-width font-normal">
                    <InputLabel
                      className="font-normal full-width"
                      htmlFor="pslf"
                    >
                      Works for Non-Profit
                    </InputLabel>
                    <Select
                      className="font-normal full-width"
                      value={this.state.employment_info.pslf ? 1 : 0}
                      onChange={e =>
                        this.setState({
                          employment_info: {
                            ...this.state.employment_info,
                            pslf: e.target.value == 1
                          }
                        })
                      }
                      inputProps={{
                        name: 'pslf',
                        id: 'pslf'
                      }}
                    >
                      <MenuItem value={0}>No</MenuItem>
                      <MenuItem value={1}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </div>
              <div className="info-block">
                {!this.state.edit_employment_info && (
                  <div>
                    <label>Occupation</label>
                    {this.getOccupation()}
                  </div>
                )}
                {this.state.edit_employment_info && (
                  <FormControl className="full-width font-normal">
                    <InputLabel
                      className="font-normal full-width"
                      htmlFor="occupation"
                    >
                      Occupation
                    </InputLabel>
                    <Select
                      className="font-normal full-width"
                      value={this.state.employment_info.occupation}
                      onChange={e =>
                        this.setState({
                          employment_info: {
                            ...this.state.employment_info,
                            occupation: e.target.value
                          }
                        })
                      }
                      inputProps={{
                        name: 'occupation',
                        id: 'occupation'
                      }}
                    >
                      <MenuItem value={0}>Other</MenuItem>
                      <MenuItem value={1}>Teacher</MenuItem>
                      <MenuItem value={6}>Public Defender</MenuItem>,
                      <MenuItem value={2}>
                        Employee at a child or family services agency
                      </MenuItem>
                      ,
                      <MenuItem value={3}>
                        Faculty member at a tribal college or university
                      </MenuItem>
                      ,<MenuItem value={4}>Firefighter</MenuItem>,
                      <MenuItem value={5}>Law enforcement officer </MenuItem>,
                      <MenuItem value={6}>
                        Librarian with master’s degree at Title I school
                      </MenuItem>
                      ,<MenuItem value={7}>Military service</MenuItem>,
                      <MenuItem value={8}>Nurse or medical technician</MenuItem>
                      ,
                      <MenuItem value={9}>
                        Professional provider of early intervention (disability)
                        services
                      </MenuItem>
                      ,<MenuItem value={10}>Public defender</MenuItem>,
                      <MenuItem value={11}>
                        Speech pathologist with master’s degree at Title I
                        school
                      </MenuItem>
                      ,
                      <MenuItem value={12}>
                        Volunteer service (AmeriCorps VISTA or Peace Corps)
                      </MenuItem>
                      ,<MenuItem value={13}>Clergy</MenuItem>
                    </Select>
                  </FormControl>
                )}
                {this.state.edit_employment_info &&
                  this.state.employment_info.occupation == 1 && (
                    <FormControl className="full-width font-normal">
                      <InputLabel
                        className="font-normal full-width"
                        htmlFor="teacher_type"
                      >
                        What type of teacher
                      </InputLabel>
                      <Select
                        className="font-normal full-width"
                        value={this.state.employment_info.teacher_type}
                        onChange={e =>
                          this.setState({
                            employment_info: {
                              ...this.state.employment_info,
                              teacher_type: e.target.value
                            }
                          })
                        }
                        inputProps={{
                          name: 'teacher_type',
                          id: 'teacher_type'
                        }}
                      >
                        <MenuItem value={20}>Other</MenuItem>
                        <MenuItem value={21}>
                          Highly qualified mathematics teacher for a secondary
                          school
                        </MenuItem>
                        <MenuItem value={22}>
                          Highly qualified science teacher for a secondary
                          school
                        </MenuItem>
                        <MenuItem value={23}>
                          Highly qualified special education teacher for a
                          secondary school. The children’s disabilities
                          corresponded to my special education training.
                        </MenuItem>
                        <MenuItem value={24}>
                          Highly qualified teacher for an elementary school
                          teaching children with disabilities. The children’s
                          disabilities corresponded to my special education
                          training.
                        </MenuItem>
                        <MenuItem value={25}>
                          Full time elementary education teacher demonstrating
                          knowledge in reading, writing
                        </MenuItem>
                        <MenuItem value={26}>
                          Secondary school teacher in a subject area relevant to
                          my academic major (if service began prior to
                          10/30/2004), or a highly qualified full time secondary
                          school education teacher.
                        </MenuItem>
                      </Select>
                    </FormControl>
                  )}
                {this.state.employment_info.occupation == 1 && (
                  <div className="info-block">
                    {!this.state.edit_employment_info && (
                      <div>
                        <label>Years of experience as teacher</label>
                        {(this.props.account.employment || {}).years_of_experience
                          || 0}
                      </div>
                    )}
                    {this.state.edit_employment_info && (
                      <TextField
                        disabled={this.state.busy}
                        type="number"
                        id="years_of_experience"
                        label="Years of working experience as teacher"
                        value={this.state.employment_info.years_of_experience}
                        onChange={e =>
                          this.setState({
                            employment_info: {
                              ...this.state.employment_info,
                              years_of_experience: e.target.value
                            }
                          })
                        }
                        className="font-normal full-width"
                      />
                    )}
                  </div>
                )}
              </div>
              {this.state.employment_info.pslf && (
                <div className="info-block">
                  {!this.state.edit_employment_info && (
                    <div>
                      <label>
                        Received PSLF {this.props.account.employment.occupation == 1 && '/TLF'}
                      </label>
                      {this.hasUserAppliedForPSLF()}
                    </div>
                  )}
                  {this.state.edit_employment_info && (
                    <FormControl className="full-width font-normal">
                      <InputLabel
                        className="font-normal full-width"
                        htmlFor="applied"
                      >
                        Applied for PSLF
                      </InputLabel>
                      <Select
                        className="font-normal full-width"
                        value={this.state.employment_info.applied ? 1 : 0}
                        onChange={e =>
                          this.setState({
                            employment_info: {
                              ...this.state.employment_info,
                              applied: e.target.value == 1
                            }
                          })
                        }
                        inputProps={{
                          name: 'applied',
                          id: 'applied'
                        }}
                      >
                        <MenuItem value={0}>No</MenuItem>
                        <MenuItem value={1}>Yes</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {this.state.edit_employment_info &&
                    this.state.employment_info.occupation == 1 && (
                      <FormControl className="full-width font-normal">
                        <InputLabel
                          className="font-normal full-width"
                          htmlFor="tlf"
                        >
                          Received TLF
                        </InputLabel>
                        <Select
                          className="font-normal full-width"
                          value={this.state.employment_info.tlf ? 1 : 0}
                          onChange={e =>
                            this.setState({
                              employment_info: {
                                ...this.state.employment_info,
                                tlf: e.target.value == 1
                              }
                            })
                          }
                          inputProps={{
                            name: 'tlf',
                            id: 'tlf'
                          }}
                        >
                          <MenuItem value={0}>No</MenuItem>
                          <MenuItem value={1}>Yes</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                </div>
              )}
              {this.state.employment_info.pslf && (
                <div className="info-block">
                  {!this.state.edit_employment_info && (
                    <div>
                      <label>Months Worked for Nonprofit</label>
                      {(this.props.account.employment || {}).pslf &&
                        (this.props.account.employment || {}).payments
                        ? (this.props.account.employment || {}).payments : 0}
                    </div>
                  )}
                  {this.state.edit_employment_info && (
                    <TextField
                      disabled={this.state.busy}
                      type="number"
                      id="payments"
                      label="Months Worked for Nonprofit"
                      value={this.state.employment_info.payments}
                      onChange={e =>
                        this.setState({
                          employment_info: {
                            ...this.state.employment_info,
                            payments: e.target.value
                          }
                        })
                      }
                      className="font-normal full-width"
                    />
                  )}
                  {!this.state.edit_employment_info && (
                    <div>
                      <label>Total non-profit companies worked for since 2007</label>
                      {(this.props.account.employment || {}).total_companies_worked_for || 0}
                    </div>
                  )}
                  {this.state.edit_employment_info && (
                    <TextField
                      disabled={this.state.busy}
                      type="number"
                      id="total_companies_worked_for"
                      label="Total non-profit companies worked for since 2007"
                      value={this.state.employment_info.total_companies_worked_for}
                      onChange={e =>
                        this.setState({
                          employment_info: {
                            ...this.state.employment_info,
                            total_companies_worked_for: e.target.value
                          }
                        })
                      }
                      className="font-normal full-width"
                    />
                  )}
                </div>
              )}
              {!this.state.edit_employment_info && (
                <div className="info-block">
                  <label>PSLF Cumulative Matched Months</label>
                  {AnalysisTools.getCummulativePSLFMonths(this.props.account)}
                </div>
              )}
              {this.state.edit_employment_info && (
                <TextField
                  disabled
                  type="number"
                  id="pslf_payments"
                  label="PSLF Cumulative Matched Months - Not Editable"
                  value={this.state.employment_info.pslf_payments}
                  onChange={e =>
                    this.setState({
                      employment_info: {
                        ...this.state.employment_info,
                        pslf_payments: e.target.value
                      }
                    })
                  }
                  className="font-normal full-width"
                />
              )}
              <div className="info-block">
                <label>TEPSLF Months</label>
                {!this.state.edit_employment_info &&
                  (this.state.employment_info.tepslf.months || 0)}
                {this.state.edit_employment_info && (
                  <TextField
                    disabled={this.state.busy}
                    type="number"
                    id="months"
                    value={this.state.employment_info.tepslf.months}
                    onChange={e =>
                      this.setState({
                        employment_info: {
                          ...this.state.employment_info,
                          tepslf: {
                            ...this.state.employment_info.tepslf,
                            months: e.target.value
                          }
                        }
                      })
                    }
                    className="font-normal full-width"
                  />
                )}
              </div>
              <div className="info-block">
                <label>Date of Hire</label>
                  {this.props.account.einData?.doh || "--"}
              </div>
              <div className="info-block">
                <h6>Employer Contribution</h6>
                {!this.state.edit_employment_info && (
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div>
                      <label>Monthly Contribution:</label>
                      {this.state.employment_info.employer_contribution ?  this.renderContributionValue() : "N/A"}
                    </div>
                    <div>
                      <label>Lifetime Cap(maximum):</label>
                      {this.state.employment_info.lifetime_contribution
                        ? `$${Formatter.money(
                            this.state.employment_info.lifetime_contribution
                          )}`
                        : 'N/A'}
                    </div>
                  </div>
                )}
                {this.state.edit_employment_info && (
                  
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <FormControl sx={{ minWidth: 80 }}>
                      <label>Type:</label>
                      <Select
                        value={this.state.employment_info.contributionType}
                        onChange={(e) => {
                          this.setState({
                            employment_info: {
                              ...this.state.employment_info,
                              contributionType: e.target.value,
                              employer_contribution: ""
                            }
                          })
                        }}
                        autoWidth
                        disabled={this.props.account.employer.services.slra || this.state.busy}
                      >
                        <MenuItem value={"percentage"}>%</MenuItem>
                        <MenuItem value={"currency"}>$</MenuItem>
                      </Select>
                    </FormControl>
                    <div style={{ paddingLeft: 5 }}>
                      <label>Monthly Contribution:</label>
                      <TextField
                        type="number"
                        id="employer_contribution"
                        value={(this.state.employment_info || {}).employer_contribution
                            || ''
                        }
                        onChange={this.updateEmploymentContribution}
                        className="font-normal"
                        onWheel={(e) => e.target.blur()}
                        disabled={this.props.account.employer.services.slra || this.state.busy}
                      />
                    </div>
                    <div style={{ paddingLeft: 10 }}>
                      <label>Lifetime Cap(maximum):</label>
                      <TextField
                        disabled={this.state.busy}
                        type="number"
                        id="lifetime_contribution"
                        value={
                          (this.state.employment_info || {}).lifetime_contribution || ''
                        }
                        onChange={e =>
                          this.setState({
                            employment_info: {
                              ...this.state.employment_info,
                              lifetime_contribution: e.target.value
                            }
                          })
                        }
                        onWheel={(e) => e.target.blur()}
                        className="font-normal"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(null, {
  showError,
  confirmAction
})(EmploymentInfo);
